import React, {useEffect, useState} from "react";
import {
    Card,
    CardHeader,
    CardBody,
    Typography,
    Tabs,
    TabsHeader,
    TabsBody,
    Tab,
    TabPanel,

} from "@material-tailwind/react";
import {ArrowDownTrayIcon, ArrowRightOnRectangleIcon} from "@heroicons/react/24/outline";
import LoginForm from "./LoginForm";
import RegisterForm from "./RegisterForm";
import {useLocation} from "react-router-dom";

export default function LoginTabs() {

    const { search } = useLocation(); // ✅ Ispravan način za uzimanje query parametara
    const searchParams = new URLSearchParams(search);
    const tabFromURL = searchParams.get("tab");

    useEffect(() => {
        if (tabFromURL === "register") {
            setSelectedTab("register");
        }
    }, [tabFromURL]);

    const dataTabs = [
        {label: "Prijava", value: "login-register", icon: ArrowRightOnRectangleIcon},
        {label: "Registracija", value: "register", icon: ArrowDownTrayIcon}
    ];

    const [selectedTab, setSelectedTab] = useState(tabFromURL === "register" ? "register" : "login-register");

    return (
        <Card className="w-full max-w-3xl mx-auto rounded-3xl overflow-hidden shadow-2xl">
            <CardHeader
                color="gray"
                floated={false}
                style={{
                    backgroundImage:
                        'linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 3)), url("/images/login-page/naslovna2.JPEG")',
                    backgroundBlendMode: 'multiply',
                }}
                className="m-0 grid place-items-center rounded-b-none py-8 px-4 bg-contain bg-center text-center"
            >
                <div className="mt-4 mb-4 rounded-full border-4 border-white/30 bg-white/20 p-3 text-white">
                    <img
                        src="/transparent logo solo.png"
                        alt="Logo"
                        className="h-20 w-20"
                    />
                </div>
                <Typography variant="h4" color="white" className="font-semibold">
                    Smart Service System
                </Typography>
                <Typography variant="h6" color="white" className="mt-1">
                    - Vaša energija, naša briga -
                </Typography>
            </CardHeader>

            <CardBody className="bg-white px-6 py-4 rounded-2xl">
                <div className="flow-root">
                    <Tabs value={selectedTab} onChange={(value) => setSelectedTab(value)} className="mb-6">
                        <TabsHeader className="flex justify-around">
                            {dataTabs.map(({ label, value, icon }) => (
                                <Tab key={value} value={value} className="px-4 py-2 text-lg font-semibold rounded-lg">
                                    <div className="flex items-center gap-2">
                                        {React.createElement(icon, { className: 'w-5 h-5' })}
                                        {label}
                                    </div>
                                </Tab>
                            ))}
                        </TabsHeader>

                        <TabsBody animate={{ initial: { y: 250 }, mount: { y: 0 }, unmount: { y: 250 } }}>
                            {dataTabs.map(({ value }) => (
                                <TabPanel key={value} value={value}>
                                    {value === 'login-register' ? <LoginForm /> : <RegisterForm />}
                                </TabPanel>
                            ))}
                        </TabsBody>
                    </Tabs>
                </div>
            </CardBody>
        </Card>
    );
}